import type * as tr from "@/lib/backend/reports.generated.types";
import type * as tm from "@/lib/backend/manufacturing2.generated.types";

export const GanttChartSource = {
    gantt: "gantt",
    planning_table: "planning_table",
    planning_table_parallel: "planning_table_parallel",
    microplan: "microplan",
    line_planning: "line_planning",
    tool_changes: "tool_changes",
    gantt_unscheduled: "gantt_unscheduled",
    stock_requirements: "stock_requirements",
} as const;

export type GanttChartSourceTypes = keyof typeof GanttChartSource;

export type ShiftTableWidgetConfig = {
    filters: {
        plant: string;
        line_groups: string[];
        lines: string[];
        weeks: number[];
    };
    weeks: number[];
    line_group_uuid: string;
    line_group_title: string;
};

export type ManufacturingData = {
    insights: tm.IEventDataEx[];
    report: tr.IReportModel;
};
